import React from 'react'
import { useSelector } from 'react-redux'
import SuccessIcon from 'transfix-icons/build/SuccessIcon'
import { Card } from 'transfix-ui/components/Card'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { ICarrierFMCSAState } from 'types/carrier'
import { IStore } from 'apps/carrier/utils/reducers'
import { ConnectedPhoneNumber } from 'apps/marketplace/components/ConnectedPhoneNumber'
import { capitalize } from 'utils/capitalize'
import { formatActivityDateTime } from 'utils/formatDatetime'
import { DISPLAY } from 'constants/display'

interface ISelector extends ICarrierFMCSAState {}

export const FMCSA = () => {
  const { error, fmcsaInfo, loading } = useSelector<IStore, ISelector>(({ carrierFMCSA }) => ({
    ...carrierFMCSA,
  }))

  const ready = !!(!loading && !error && fmcsaInfo)
  const {
    updatedAt,
    rating,
    operatingStatus,
    driverOutOfServicePercent: driverOOS,
    vehicleOutOfServicePercent: vehicleOOS,
    brokerAuthority,
    numFatalCrashes,
    numInjuryCrashes,
    phoneNumber,
    carrierApplication: { dotNumber = '' } = {},
  } = fmcsaInfo || {}

  return (
    <Card>
      <div className='pv4'>
        <h3>FMCSA</h3>
        {ready && updatedAt && <p>Last synced {formatActivityDateTime(updatedAt) || DISPLAY.na}</p>}
      </div>
      {loading && <Spinner position='relative' />}
      {error && <InlineMessage message={error} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
      {ready && fmcsaInfo && (
        <>
          <p>
            <SuccessIcon color='info' size='large' />
            &nbsp;Safety Rating: {capitalize(rating) || DISPLAY.na}
          </p>
          <p>
            <div className='text-secondary'>Operating Status:</div>
            {capitalize(operatingStatus) || DISPLAY.na}
          </p>
          <p>
            <div className='text-secondary'>Driver OOS:</div>
            {driverOOS ? `${driverOOS}%` : DISPLAY.na}
          </p>
          <p>
            <div className='text-secondary'>Vehicle OOS:</div>
            {vehicleOOS ? `${vehicleOOS}%` : DISPLAY.na}
          </p>
          <p>
            <div className='text-secondary'>Broker Authority:</div>
            {brokerAuthority || DISPLAY.na}
          </p>
          <p>
            <div className='text-secondary'>Fatal Crashes:</div>
            {numFatalCrashes}
          </p>
          <p>
            <div className='text-secondary'>Injury Crashes:</div>
            {numInjuryCrashes}
          </p>
          <p>
            <div className='text-secondary'>Contact Phone:</div>
            {phoneNumber ? <ConnectedPhoneNumber phoneNumber={phoneNumber} /> : DISPLAY.na}
          </p>
          <p>
            <a
              href={`https://ai.fmcsa.dot.gov/SMS/Carrier/${dotNumber}/CompleteProfile.aspx`}
              target='_blank'
              rel='noopener noreferrer'>
              View details on FMCSA SMS
            </a>
          </p>
        </>
      )}
    </Card>
  )
}
